import axios from 'axios';
import { BUSINESS_ADMIN_HOST } from 'api/constants';

const BASE_PACKAGE_URL = `${BUSINESS_ADMIN_HOST}/v1/subscription-products`;
const CUSTOM_PACKAGE_URL = `${BUSINESS_ADMIN_HOST}/v1/products`;
const TERRITORY_URL = `${BUSINESS_ADMIN_HOST}/v1/products/territories`;
const LEAD_SOURCE_URL = `${BUSINESS_ADMIN_HOST}/v1/products/lead-sources`;
const BONUS_SUBSCRIPTION_TYPES_URL = `${BUSINESS_ADMIN_HOST}/v1/products/bonus-subscription-types`;

export function getBasePackagesApi() {
  return axios.get(BASE_PACKAGE_URL);
}

export function getCustomPackagesApi() {
  return axios.get(CUSTOM_PACKAGE_URL);
}

export function getTerritoriesApi() {
  return axios.get(TERRITORY_URL);
}

export function getLeadSourcesApi() {
  return axios.get(LEAD_SOURCE_URL);
}

export function getBonusSubscriptionTypesApi() {
  return axios.get(BONUS_SUBSCRIPTION_TYPES_URL);
}

export function createPackageApi(packageData) {
  return axios.post(CUSTOM_PACKAGE_URL, packageData);
}

export function updatePackageApi(packageData) {
  return axios.put(`${CUSTOM_PACKAGE_URL}/${packageData.id}`, packageData);
}

export function deletePackageApi(packageId) {
  return axios.delete(`${CUSTOM_PACKAGE_URL}/${packageId}`);
}

export function getBillingPackageLogs(page, size) {
  return axios.get(
    `${BUSINESS_ADMIN_HOST}/v1/logs?group=products_subscription`,
    {
      params: { page, size },
    }
  );
}
